/* GallopLights – global theme scripts (no dependencies). Loaded with defer in <head>,
   so it runs before the section scripts (cro-product.js, cro-cta.js, variant-picker.js). */
(function () {
  'use strict';
  if (window.themeCart) { return; }

  var T = window.theme = window.theme || {};
  T.routes = T.routes || {};
  T.strings = T.strings || {};
  T.mainHandle = T.mainHandle || 'led-horse-harness-set';
  T.protHandle = T.protHandle || 'shipping-protection';
  T.prioHandle = T.prioHandle || 'priority-processing';
  T.routes.cart = T.routes.cart || '/cart';
  T.routes.cartJs = T.routes.cartJs || '/cart.js';
  T.routes.cartAdd = T.routes.cartAdd || '/cart/add.js';
  T.routes.cartChange = T.routes.cartChange || '/cart/change.js';
  var D = document;
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || D).querySelectorAll(s)); };

  /* ---------------------------------------------------------------
     Money: same output as Liquid's | money for the shop's money format
  ---------------------------------------------------------------- */
  function groupNum(cents, decimals, thousands, decimal) {
    var parts = (Math.round(Number(cents) || 0) / 100).toFixed(decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var fmt = T.moneyFormat;
    if (typeof fmt !== 'string' || fmt.indexOf('amount') === -1) {
      try {
        return new Intl.NumberFormat(T.locale || 'en-US', { style: 'currency', currency: T.currency || 'USD' }).format((Number(cents) || 0) / 100);
      } catch (e) {
        return '$' + groupNum(cents, 2, ',', '.');
      }
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return groupNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return groupNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return groupNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return groupNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return groupNum(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return groupNum(cents, 0, ' ', ',');
        default: return groupNum(cents, 2, ',', '.');
      }
    });
  }
  T.money = money;

  function request(url, opts) {
    opts = opts || {};
    opts.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw data; }
        return data;
      }, function () {
        throw {}; /* non-JSON error page: caller shows the generic error string */
      });
    });
  }
  function post(url, body) { return request(url, { method: 'POST', body: JSON.stringify(body) }); }
  function getCart() { return request(T.routes.cartJs + '?_=' + Date.now()); }

  function hasHandle(cart, handle) {
    return cart.items.some(function (i) { return i.handle === handle; });
  }
  function isAddon(i) { return i.handle === T.protHandle || i.handle === T.prioHandle; }
  /* any real product (the set or a single part) unlocks checkout and the add-ons */
  function hasProduct(cart) { return cart.items.some(function (i) { return !isAddon(i); }); }

  /* ---------------------------------------------------------------
     Add-on guard (Shipping Protection + Priority Processing): add-ons can
     never be bought alone and are always quantity 1.
     If the cart has an add-on but no product, remove it.
  ---------------------------------------------------------------- */
  function guard(cart) {
    var hasMain = hasProduct(cart);
    var addons = cart.items.filter(isAddon);
    if (!addons.length) { return Promise.resolve({ cart: cart, changed: false }); }
    var chain = Promise.resolve(cart);
    var changed = false;
    addons.forEach(function (i) {
      if (!hasMain) {
        changed = true;
        chain = chain.then(function () { return post(T.routes.cartChange, { id: i.key, quantity: 0 }); });
      } else if (i.quantity !== 1) {
        changed = true;
        chain = chain.then(function () { return post(T.routes.cartChange, { id: i.key, quantity: 1 }); });
      }
    });
    return chain.then(function (c) { return { cart: c, changed: changed }; });
  }

  function applyCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    var hasMain = hasProduct(cart);
    $$('[data-checkout-form]').forEach(function (el) { el.hidden = !hasMain; });
    $$('[data-checkout]').forEach(function (el) { el.disabled = !hasMain; });
    $$('[data-need-main]').forEach(function (el) { el.hidden = hasMain; });
  }

  function refresh() {
    return getCart()
      .then(function (cart) {
        /* hide checkout immediately if an add-on is alone, even if the cleanup below fails */
        applyCart(cart);
        return guard(cart);
      })
      .then(function (res) {
        applyCart(res.cart);
        try { D.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: res.cart, changed: res.changed } })); } catch (e1) { /* old browser */ }
        return res;
      })
      .catch(function () { /* silent */ });
  }

  /* shared with cart-drawer.js, cro-product.js and cro-cta.js */
  window.themeCart = { getCart: getCart, post: post, guard: guard, hasHandle: hasHandle, hasProduct: hasProduct, applyCart: applyCart, refresh: refresh, busy: busy };

  /* ---------------------------------------------------------------
     Cart drawer helpers: error line (Shopify's description, else the generic string),
     keyboard focus memory and a redraw with one retry (all live in cart-drawer.js)
  ---------------------------------------------------------------- */
  function errorText(err) {
    return (err && typeof err.description === 'string' && err.description) || T.strings.error || 'Error';
  }
  function drawerSay(text) {
    var cd = window.cartDrawer;
    if (cd && cd.say) { cd.say(text); }
  }
  function drawerRemember(el) {
    var cd = window.cartDrawer;
    if (cd && cd.remember) { cd.remember(el); }
  }
  /* drawer quantity changes still on their way: a redraw that lands meanwhile (e.g. the one started by opening the
     drawer) keeps its new -/+/remove buttons locked, see render() in cart-drawer.js */
  var pending = 0;
  function busy() { return pending > 0; }
  /* resolves false if the drawer still shows the old cart after two tries */
  function redraw() {
    var cd = window.cartDrawer;
    if (!cd || !cd.render) { return Promise.resolve(true); }
    return cd.render().then(function (ok) { return ok === false ? cd.render() : ok; });
  }

  /* ---------------------------------------------------------------
     Cart drawer: quantity / remove buttons
  ---------------------------------------------------------------- */
  D.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (!btn || btn.disabled) { return; }
    e.preventDefault();
    /* every -/+/remove button holds an absolute quantity from the last render (e.g. "-" on qty 1 = 0), so after a
       change the others are stale ("+" then a quick "-" would send 0 and empty the cart): lock them all until the
       drawer has been redrawn from the new cart */
    var scope = (btn.closest && btn.closest('[data-cd-root]')) || D;
    var locked = $$('[data-qty]', scope).filter(function (b) { return !b.disabled; });
    function unlock() { locked.forEach(function (b) { b.disabled = false; }); }
    drawerRemember(btn);
    locked.forEach(function (b) { b.disabled = true; });
    pending++;
    post(T.routes.cartChange, { id: btn.getAttribute('data-key'), quantity: parseInt(btn.getAttribute('data-qty'), 10) || 0 })
      .then(function () { return refresh(); })
      /* refresh() and redraw() never reject, so the error handler below only runs when the change itself failed */
      .then(function () { pending--; return redraw(); })
      .then(function (ok) {
        /* the change went through but the drawer still shows the old quantities: keep them locked (a reload or
           the next open redraws) instead of letting a stale button send a wrong quantity */
        if (ok === false) { drawerSay(errorText()); return; }
        unlock();
        drawerSay('');
      }, function (err) { pending--; unlock(); drawerSay(errorText(err)); refresh(); });
  });

  /* Cart drawer: add-on checkboxes (only allowed together with the main product, qty 1) */
  var ADDON_ATTRS = [
    { attr: 'data-add-protection', handle: function () { return T.protHandle; } },
    { attr: 'data-add-priority', handle: function () { return T.prioHandle; } }
  ];
  D.addEventListener('change', function (e) {
    var box = e.target;
    if (!box.matches || !box.checked) { return; }
    var def = ADDON_ATTRS.filter(function (a) { return box.matches('[' + a.attr + ']'); })[0];
    if (!def) { return; }
    var handle = def.handle();
    drawerRemember(box);
    box.disabled = true;
    getCart()
      .then(function (cart) {
        if (!hasProduct(cart)) { throw new Error('no main'); }
        if (hasHandle(cart, handle)) { return null; }
        return post(T.routes.cartAdd, { items: [{ id: parseInt(box.getAttribute(def.attr), 10), quantity: 1 }] });
      })
      .then(function () { return refresh(); })
      .then(redraw)
      /* added, but if the redraw failed the box stays disabled on the old markup */
      .then(function (ok) { drawerSay(ok === false ? errorText() : ''); },
        function (err) { box.disabled = false; box.checked = false; drawerSay(errorText(err)); refresh(); });
  });

  /* ---------------------------------------------------------------
     Header menu (<details>): close on outside click and Escape
  ---------------------------------------------------------------- */
  $$('[data-hdr-menu]').forEach(function (menu) {
    D.addEventListener('click', function (e) {
      if (menu.open && !menu.contains(e.target)) { menu.open = false; }
    });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) {
        menu.open = false;
        var s = menu.querySelector('summary');
        if (s) { s.focus(); }
      }
    });
  });

  /* Announcement bar: under prefers-reduced-motion the marquee is hidden and the static bar shows the first
     message only (no auto-rotating content). */

  /* Initial pass on every page: sync count and enforce the add-on rules */
  refresh();
})();
